import React, { useEffect } from 'react';
import './PaymentSuccess.css';

const CONFETTI_COLORS = ['#2563EB', '#10B981', '#F59E0B', '#EF4444', '#8B5CF6', '#EC4899', '#00e83a'];

const confettiPieces = Array.from({ length: 40 }, (_, i) => ({
    id: i,
    color: CONFETTI_COLORS[i % CONFETTI_COLORS.length],
    left: `${Math.random() * 100}%`,
    delay: `${Math.random() * 0.6}s`,
    duration: `${0.8 + Math.random() * 0.8}s`,
    rotate: `${Math.random() * 360}deg`,
    size: `${6 + Math.random() * 8}px`,
}));

const PaymentSuccess = ({ amount, currency, transNumber, onClose }) => {
    useEffect(() => {
        const t = setTimeout(onClose, 4000);
        return () => clearTimeout(t);
    }, [onClose]);

    return (
        <div className="ps-overlay">
            <div className="ps-confetti-container">
                {confettiPieces.map(p => (
                    <span
                        key={p.id}
                        className="ps-confetti-piece"
                        style={{
                            left: p.left,
                            background: p.color,
                            animationDelay: p.delay,
                            animationDuration: p.duration,
                            width: p.size,
                            height: p.size,
                            transform: `rotate(${p.rotate})`,
                        }}
                    />
                ))}
            </div>

            <div className="ps-card">
                <div className="ps-circle">
                    <svg className="ps-tick" viewBox="0 0 52 52">
                        <circle className="ps-tick-circle" cx="26" cy="26" r="25" />
                        <path className="ps-tick-check" d="M14 27 l8 8 l16 -16" />
                    </svg>
                </div>

                <p className="ps-title">Payment Successful!</p>
                {amount && (
                    <p className="ps-amount">{currency || ''} {amount}</p>
                )}
                {transNumber && (
                    <p className="ps-ref">Ref: {transNumber}</p>
                )}
                <button className="ps-btn" onClick={onClose}>Done</button>
            </div>
        </div>
    );
};

export default PaymentSuccess;
